import Parser from "rss-parser";

function filterOnSSL(items: Parser.Item[]) {
  return items.filter(function (item: Parser.Item) {
    if (!item || !item.link) return false;
    const linkIsSecure = item.link.indexOf("https") !== -1;
    const enclosureIsSecure = item.enclosure?.url
      ? item.enclosure.url.indexOf("https") !== -1
      : true; // no enclosure URL to check, so this condition is not applicable
    return linkIsSecure && enclosureIsSecure;
  });
}

export default filterOnSSL;
